const flashwordIt = {
    "flashword": {
        "app-name": "Flashword",
        "description": {
            "1": `Ti è mai capitato di sentire una parola che non conoscevi, di cercarne il significato, e poi di
            ben presto dimenticartene? Se sì, Flashword arriva in tuo soccorso!`,
            "2": `Con Flashword puoi salvare le parole che senti o impari in qualsiasi modo.
            Puoi cercarne una definizione usando i dizionari di sistema e puoi prendere appunti per ogni parola,
            magari per annotarti una traduzione, magari per ricordarti il contesto in cui hai sentito quella parola
            la prima volta, magari per evidenziare interessanti casi d'uso. Puoi anche dividere le parole in categorie
            di tua scelta per organizzare velocemente tutto ciò che salvi nell'app!`,
            "3": "Flashword è la prima app che ho sviluppato!",
            "4": `È iniziato come un progetto personale per creare qualcosa che mi serviva personalmente.
            Tutte le volte che mi capitava di imparare una nuova parola (magari guardando un film o una serie TV
            in inglese, o magari anche qualche parola italiana poco utilizzata) la cercavo sul dizionario del telefono,
            ma poi la dimenticavo quasi subito. Ho quindi deciso di creare un posto dove salvare queste parole e tornare
            in seguito, così da non dimenticarle, ed è così che è nata l'idea per Flashword!`
        },
        "app-store-link": "<0>Link App Store</0>",
        "github-link": "<0>Repository GitHub</0>",
        "privacy-policy": {
            "title": "Privacy policy di Flashword",
            "description": {
                "1": `Flashword è stata creata ed è mantenuta da Alessio Mason, uno sviluppatore indipendente italiano.`,
                "2": `Flashword non raccoglie alcun dato su di te o sulle parole e categorie salvate nell'app.
            Tutti i dati sono salvati in locale e non vengono mai raccolti. Se hai eseguito l'accesso con il tuo Apple
            ID, tutti i dati vengono automaticamente sincronizzati tra tutti i tuoi dispositivi attraverso iCloud,
            rimanendo quindi completamente inaccessibili a chiunque tranne che a te.`,
                "3": `L'app offre una funzionalità di quiz per mettere alla prova le proprie conoscenze delle parole
                salvate. I quiz sono generati con Apple Intelligence e si basano sulle parole e categorie salvate
                nell'app dall'utente: i dati vengono quindi condivisi con il modello di Apple Intelligence,
                eseguito in locale, e non lasciano quindi in alcun momento il dispositivo. I dati non vengono
                utilizzati per allenare alcun modello di intelligenza artificiale.`,
                "4": `Per qualsiasi domanda o commento riguardo Flashword (e la sua privacy policy),
                puoi contattarmi all'indirizzo <1>dev@alessiomason.it</1>.`
            },
            "last-updated": "Ultimo aggiornamento: sabato 30 maggio 2026",
            "link": "<0>Privacy policy</0>",
        },
        "terms-of-use": {
            "title": "Termini di utilizzo di Flashword",
            "description": {
                "1": "Flashword è governata dall'<1>EULA Standard per le app di Apple</1>.",
                "2": `Per qualsiasi domanda o commento riguardo Flashword (e i suoi termini di utilizzo),
                puoi contattarmi all'indirizzo <1>dev@alessiomason.it</1>.`
            },
            "last-updated": "Ultimo aggiornamento: sabato 30 maggio 2026",
            "link": "<0>Termini di utilizzo</0>",
        }
    }
}

const flashwordEn = {
    "flashword": {
        "app-name": "Flashword",
        "description": {
            "1": `Ever heard a word you did not know, looked it up, and then quickly forgot about it?
            If that is the case, Flashword comes to the rescue!`,
            "2": `With Flashword, you can save new words you hear or learn in any way.
            You can look them up using the system's dictionaries and you can take notes for every word,
            maybe to jot down a translation, maybe to remember the context you first heard that word in,
            maybe to highlight interesting use cases. You can also divide the words into categories of your choosing
            to quickly organize the words you save!`,
            "3": "Flashword is the first app I developed!",
            "4": `It started as a personal project to create something I personally needed.
            Every time I would learn a new word (maybe watching a film or TV series in English, or even some rarely-used
            Italian word) I would look it up on my phone's dictionary, but then quickly forget it.
            So I decided to create a place where to store and revisit these words, so that I wouldn't forget them,
            and that's how the idea for Flashword came to be!`
        },
        "app-store-link": "<0>App Store link</0>",
        "github-link": "<0>GitHub repository</0>",
        "privacy-policy": {
            "title": "Flashword's privacy policy",
            "description": {
                "1": `Flashword is owned and maintained by Alessio Mason, an independent developer based in Italy.`,
                "2": `Flashword does not collect any data about you or the words or categories you save in the app.
            All data are saved locally and are never collected. If you signed in with your Apple ID, all data are
            automatically synced across all your devices using iCloud, thus remaining completely inaccessible
            to anyone other than yourself.`,
                "3": `The app offers a quiz functionality to test one's knowledge of the words saved. Quizzes are
                generated with Apple Intelligence and are based on the words and categories saved in the app
                by the user: the data are therefore shared with the Apple Intelligence model, which is run locally,
                and so they never leave the device. Data are not used to train any artificial intelligence model.`,
                "4": `For any question or comment regarding Flashword (and its privacy policy),
                you can contact me at <1>dev@alessiomason.it</1>.`
            },
            "last-updated": "Last updated: Saturday, 30 May 2026",
            "link": "<0>Privacy policy</0>",
        },
        "terms-of-use": {
            "title": "Flashword's terms of use",
            "description": {
                "1": "Flashword is governed by <1>Apple's Standard EULA for apps</1>.",
                "2": `For any question or comment regarding Flashword (and its terms of use),
                you can contact me at <1>dev@alessiomason.it</1>.`
            },
            "last-updated": "Last updated: Saturday, 30 May 2026",
            "link": "<0>Terms of use</0>",
        }
    }
}

export {flashwordIt, flashwordEn};